export default __webpack_public_path__ + "static/media/BR - Intel Analyst.32792130.png";